import { ApiTypes } from "types"

import DeviceRebootModal from "modals/DeviceRebootModal/DeviceRebootModal"
import { PerformanceTestActionsModal } from "modals/PerformanceTestActionsModal"
import { StatsReportModal } from "modals/StatsReportModal"
import { ContentWrapper } from "components/common/ContentWrapper"
import { Pagination } from "components/common/Pagination"
import EditColumnsButton from "components/EditColumnsButton"
import TableWrapper from "components/table/TableWrapper"

import { useMonitoringPageContent } from "./useMonitoringPageContent"

interface MonitoringPageContentViewProps {
  devices: ApiTypes.Model.Device[]
  isFetching: boolean
  meta: ApiTypes.Model.Pagination | undefined
  onPerformanceTestSuccess: () => void
}

const MonitoringPageContentView = ({
  devices,
  isFetching,
  meta,
  onPerformanceTestSuccess,
}: MonitoringPageContentViewProps) => {
  const {
    defaultPeriod,
    defaultTab,
    getRowActions,
    handleCancelStatsReportModal,
    handleClearMonitoringReportAnnotations,
    handleClosePerformanceTestActionsModal,
    handleCloseRebootModal,
    handlePerformanceTestSuccess,
    isFetchingTableColumns,
    isMobileDevice,
    monitoringReportAnnotations,
    selectedDeviceForStatsReport,
    showPerformanceTestActionsModal,
    showRebootModalDevice,
    tableHeaderCells,
    tableData,
  } = useMonitoringPageContent({ devices, onPerformanceTestSuccess })

  return (
    <>
      <ContentWrapper
        title="Monitoring Page"
        renderHeaderAccessoryView={() => (
          <EditColumnsButton tableName="contractor_monitoring_list" tableHeaderCells={tableHeaderCells} />
        )}
      >
        <TableWrapper
          headerCells={tableHeaderCells}
          columnsLoaded={!isFetchingTableColumns}
          data={tableData}
          getRowActions={getRowActions}
          isLoading={isFetching}
          isMobileDevice={isMobileDevice}
        />
        <Pagination meta={meta} />
        {showRebootModalDevice && <DeviceRebootModal device={showRebootModalDevice} onClose={handleCloseRebootModal} />}
        {showPerformanceTestActionsModal && (
          <PerformanceTestActionsModal
            onCancel={handleClosePerformanceTestActionsModal}
            onSuccess={handlePerformanceTestSuccess}
          />
        )}
      </ContentWrapper>
      {selectedDeviceForStatsReport && (
        <StatsReportModal
          onCancel={handleCancelStatsReportModal}
          device={selectedDeviceForStatsReport}
          monitoringReportAnnotations={monitoringReportAnnotations}
          onClearMonitoringReportAnnotations={handleClearMonitoringReportAnnotations}
          defaultPeriod={defaultPeriod}
          defaultTab={defaultTab}
        />
      )}
    </>
  )
}

export default MonitoringPageContentView
